import axios from "../axios/AxiosInstance";

const refusedStatus = (status) => /refus/i.test(String(status || ""));

export const toAcompteRow = (acompte) => ({
  id: acompte._id,
  candidateId: acompte.candidate?._id || acompte.candidate,
  name: acompte.name,
  requestedAmount: Number(acompte.askedAmount),
  paidAmount: Number(acompte.validatedAmount) > 0 ? Number(acompte.validatedAmount) : null,
  paymentDate: acompte.paymentDate,
  reason: acompte.motif || "",
  refusalReason: acompte.refusalReason || acompte.rejectionReason || (refusedStatus(acompte.status) ? acompte.motif || "" : ""),
  source: acompte.provenance,
  status: acompte.status,
  author: acompte.createdByName || "",
  createdAt: acompte.createdAt,
});

export async function listAcomptes(signal) {
  const { data } = await axios.get("acompte/freelance", { signal });
  return Array.isArray(data) ? data.map(toAcompteRow) : [];
}

export async function createAcompte({ candidateId, amount, paymentDate, reason }) {
  const payload = {
    candidateId,
    amount: Number(amount),
    motif: reason?.trim() || "",
  };
  if (paymentDate) payload.paymentDate = paymentDate;
  const { data } = await axios.post("acompte/freelance", payload);
  return toAcompteRow(data);
}
